import axios from 'axios';

export default {

    /**
     * Get a list of all product ranges
     *
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getRanges() {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products')
            .then(response => response.data.data);
    },

    /**
     * Get a list of all models for a given product range
     *
     * @param range_slug
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getModels(range_slug) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug)
            .then(response => response.data.data);
    },

    /**
     * Get a list of all configurations for this range
     *
     * @param range_slug
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getConfigurations(range_slug) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug+'/configurations')
            .then(response => response.data.data);
    },

    /**
     * Get a single product model along with all of its features, variants, exclusions and validation
     *
     * @param range_slug
     * @param model_slug
     * @param variants_hash
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getModel(range_slug, model_slug, variants_hash) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug+'/'+model_slug, {
                params: {
                    ...(variants_hash ? { options_hash: variants_hash, } : {})
                }
            })
            .then(response => response.data.data);
    },

    /**
     * Get the closest image available to the current configuration
     *
     * @param range_slug
     * @param model_slug
     * @param variants_hash
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getImages(range_slug, model_slug, variants_hash) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug+'/'+model_slug+'/images', {
                params: {
                    options_hash: variants_hash,
                }
            })
            .then(response => response.data.images);
    },

    /**
     * Get the pricing for the current configuration
     *
     * @param range_slug
     * @param model_slug
     * @param variants_hash
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getPrice(range_slug, model_slug, variants_hash) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug+'/'+model_slug+'/price', {
                params: {
                    options_hash: variants_hash,
                }
            })
            .then(response => response.data);
    },


    /**
     * Get descriptions and help information for range, model and features
     *
     * @param range_slug
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    getDescriptions(range_slug) {
        return axios
            .get(process.env.VUE_APP_API_ROOT_URL+'/products/'+range_slug+'/descriptions')
            .then(response => response.data);
    },
};
